// Single source of truth for the fair demo (front-end-only mock) mode.
//
// The demo build ships a fully self-contained SPA with NO backend: every HTTP
// call, the Firebase Realtime Database and Firebase Auth are replaced by
// in-browser mocks so the platform can run on Firebase Hosting (or fully
// offline at a booth) showing rich, curated data.
//
// Enabled at build time via `DEMO_MODE=true` (see the `build:demo` npm script).
// When false, none of the demo code paths run and the app behaves normally.
export const DEMO_MODE = process.env.DEMO_MODE === 'true'

// The fake authenticated user used while auth is bypassed.
export const DEMO_USER = {
  uid: 'demo-user-inobram',
  email: 'demo@inobram.com.br',
  displayName: 'Demonstração Inobram'
}



// WEBPACK FOOTER //
// ./src/demo/demo-mode.js